<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"RECRUITER.LISTVIEW" | translate}} </h5>
        <div class="edit-icons">
            <i class="material-icons" (click)="closeDialog()">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column">

        <div class="header border-b-i d-flex align-items-center flex-wrap gap-3 pt-4 pb-4">
            <div class="d-flex me-auto align-items-center flex-wrap me-2 gap-2">
                <div>
                    <mat-form-field class="c-d-r" appearance="fill">
                        <mat-date-range-input [rangePicker]="picker" [formGroup]="dateForm">
                            <input matStartDate placeholder="Start date" formControlName="start"
                                (click)="picker.open()" />
                            <input matEndDate placeholder="End date" formControlName="end" (click)="picker.open()" />
                        </mat-date-range-input>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex flex-wrap" style="gap: 10px 0px">
                <div class="search-cont ">
                    <div class="s-in form-input">
                        <mat-icon class="input-icon">search</mat-icon>
                        <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control"
                            [(ngModel)]="searchInput" (input)="onSearch($event)" (keyup.enter)="onGo()" />
                    </div>
                    <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
                </div>
            </div>
        </div>
        <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center flex-grow-1 "
            style="position: relative" *ngIf="isSpinnerLoading">
            <div class="custom-loader"></div>
        </div>
        <div class="table-container flex-grow-1" *ngIf="!isSpinnerLoading">
            <div class=" d-flex flex-column mt-4 border-n  mb-3" *ngFor="let data of newListArr">
                <div class="date-div d-flex gap-2">{{data.date}} <div class="reg-txt">
                        ({{data.tot_user}}/{{data.tot_qty}})</div>
                </div>
                <div *ngFor="let innerData of data.records">
                    <div class="cat-div d-flex align-items-center gap-2 justify-content-between ">
                        <div class="d-flex gap-2 align-items-center">
                            <div class="percentage-div red yellow green" [ngClass]="{
                                'danger-box': innerData.per === 0,
                                'warning-box': innerData.per > 0 && innerData.per < 100,
                                'success-box': innerData.per >= 100
                              }">
                                {{innerData.per}}%
                            </div>
                            <div class="title">
                                {{innerData.j_c}}
                            </div>
                            <div class="date">
                                {{innerData.st_ti}} - {{innerData.ed_ti}}
                            </div>
                        </div>
                        <div class="d-flex gap-2 me-2">
                            <div class="bg-no" [ngClass]="{
                                'danger-box': innerData.per === 0,
                                'warning-box': innerData.per > 0 && innerData.per < 100,
                                'success-box': innerData.per >= 100
                              }">({{innerData.used}}/{{innerData.qty}})</div>
                            <img class="cursor-pointer mb-1" (click)="onOpendetailsModel(innerData.j_c,data.date)"
                                src="assets/images/icons/view_icon.svg" alt="">
                        </div>



                    </div>
                    <div class="d-flex flex-column mt-0 pse-25">
                        <mat-expansion-panel *ngFor="let dataDetails of innerData.user_records; let i = index"
                            class="height-55" expanded="true" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="me-2">
                                <mat-panel-title>
                                    <div class="d-flex flex-column">
                                        <div class="mat-date">{{dataDetails.st_ti}} - {{dataDetails.ed_ti}} -
                                            {{dataDetails.j_c}} </div>
                                        <div class="d-flex gap-2">
                                            <img src="assets/images/icons/add_ic.png" alt="">
                                            <div class="mat-add hidden-t">{{dataDetails.add}} </div>
                                        </div>
                                    </div>
                                </mat-panel-title>
                                <mat-panel-description>
                                    <i class="material-icons cursor-pointer" (click)="onEdit(dataDetails,'normal')">edit</i>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div class="inner-container">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="det-con">
                                        <div
                                            class="inner-header  border-b-c d-flex align-items-center justify-content-between">
                                            {{dataDetails.available.length}} Available
                                            <i *ngIf="dataDetails.available.length != 0"
                                                class="material-icons cursor-pointer"
                                                [matMenuTriggerFor]="menu">more_vert</i>

                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item color="warn" (click)="acceptAll(dataDetails.id)"
                                                    type="button">
                                                    <span>{{'Accept All' | translate}}</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                        <div class="inner-body">

                                            <div class="det-div det-div-off d-flex  align-items-center justify-content-center"
                                                *ngIf="dataDetails.available.length == 0 ">
                                                No user vailable

                                            </div>

                                            <div class="det-div d-flex justify-content-between gap-2"
                                                *ngFor="let avaData of dataDetails.available">
                                                <div class="user-d d-flex align-items-center "
                                                    (click)="onViewEmployee(avaData.em_i)">

                                                    <img class="user-p" *ngIf="avaData.profile_picture"
                                                        [src]="avaData.profile_picture" alt="">
                                                    <img class="user-p" *ngIf="!avaData.profile_picture"
                                                        src="assets/images/icons/employee.png" alt="">

                                                    <div class="">
                                                        <div class="title">{{avaData.first_name}} {{avaData.last_name}}
                                                        </div>
                                                        <div class="sub-title">{{avaData.email}}</div>
                                                    </div>
                                                </div>
                                                <div class="btn btn-outline-primary"
                                                    (click)="onConfirmationModal(avaData,1,dataDetails.id)">
                                                    Book</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="det-con">
                                        <div
                                            class="inner-header clr-g border-b-c d-flex align-items-center justify-content-between">
                                            {{dataDetails.book.length}} Booked / <div class="me-auto clr-o"> {{
                                                dataDetails.qty }} Needed</div>
                                            <!-- <div class="d-flex gap-1">
                                                <i class="material-icons cursor-pointer"
                                                    [matMenuTriggerFor]="menu2">more_vert</i>
                                                <mat-menu #menu="matMenu">
                                                    <button mat-menu-item color="warn"  type="button">
                                                        <span>{{'Reject All' | translate}}</span>
                                                    </button>
                                                </mat-menu>
                                            </div> -->
                                        </div>
                                        <div class="inner-body">
                                            <div class="det-div det-div-off d-flex align-items-center justify-content-center"
                                                *ngIf="dataDetails.book.length == 0 ">
                                                No any user Booked

                                            </div>
                                            <div class="det-div  d-flex justify-content-between gap-2"
                                                *ngFor="let bookData of dataDetails.book">
                                                <div class="user-d d-flex align-items-center "
                                                    (click)="onViewEmployee(bookData.em_i)">

                                                    <img class="user-p" *ngIf="bookData.profile_picture"
                                                        [src]="bookData.profile_picture" alt="">
                                                    <img class="user-p" *ngIf="!bookData.profile_picture"
                                                        src="assets/images/icons/employee.png" alt="">

                                                    <div class="">
                                                        <div class="title">{{bookData.first_name}}
                                                            {{bookData.last_name}}</div>
                                                        <div class="sub-title">{{bookData.email}}</div>
                                                    </div>
                                                </div>
                                                <div class="btn btn-outline-primary"
                                                    (click)="onConfirmationModal(bookData,0,dataDetails.id)">
                                                    Unbook</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </div>
                <div *ngIf="data.records.length == 0 ">
                    <!-- <div class="cat-div d-flex gap-2 ">
                        - 
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>